import { createSlice } from "@reduxjs/toolkit"
import { initialFilterTable } from "../../component/atoms/Tabel"

const initState = {
  pageData: [],
  pageDataActivity: [],
  pageActivity: initialFilterTable,
  page: initialFilterTable,
  combobox: [],
  data: undefined,
  actions: false,
  plantingEvent: null,
  rejectReasons: [],
  activityList: [],
  historyList: [],
  plantingStatusEnum: [],
  confirm: undefined,
  mapDetail: undefined,
  responsePost: undefined,
  bulkList: [],
  blockDetail: undefined,
  listAreaBlock: [],
  listInspection: [],
  activityDetail: undefined,
  activityDownload: undefined,
  areaDebt: undefined,
  paymentSummary: undefined,
  mainTabs: [],
  subFilters: [],
  detailReport: undefined,
  unassignFarmerReasons: [],
  statusHistory: []
}

export const AreaSlice = createSlice({
  name: "area",
  initialState: initState,
  reducers: {
    getPage: (state, action) => {
      state.data = action.payload
    },
    getDebt: (state, action) => {
      state.areaDebt = action.payload
    },
    getMapDetail: (state, action) => {
      state.mapDetail = action.payload
    },
    getPlantingEvent: (state, action) => {
      state.plantingEvent = action.payload
    },
    getRejectReason: (state, action) => {
      if (Array.isArray(action.payload)) {
        state.rejectReasons = action.payload
      }
    },
    setUnassignFarmerReasons: (state, action) => {
      if (Array.isArray(action.payload)) {
        state.unassignFarmerReasons = action.payload
      }
    },
    setCombobox: (state, action) => {
      state.combobox = action.payload
    },
    setPageData: (state, action) => {
      const { pageData, page } = action.payload
      state.pageData = pageData
      state.page = page
    },
    setPaymentSummary: (state, action) => {
      state.paymentSummary = action.payload
    },
    setPageDataActivity: (state, action) => {
      const { pageData, page } = action.payload
      state.pageDataActivity = pageData
      state.pageActivity = page
    },
    setActions: (state, action) => {
      state.actions = action.payload
    },
    setActivityList: (state, action) => {
      state.activityList = action.payload
    },
    setHistoryList: (state, action) => {
      state.historyList = action.payload
    },
    setConfirm: (state, action) => {
      state.confirm = action.payload
    },
    setPlantingStatusEnum: (state, action) => {
      state.plantingStatusEnum = action.payload
    },
    setResponsePost: (state, action) => {
      state.responsePost = action.payload
    },
    setBulkList: (state, action) => {
      state.bulkList = action.payload
    },
    setBlockDetail: (state, action) => {
      state.blockDetail = action.payload
    },
    setListAreaBlock: (state, action) => {
      state.listAreaBlock = action.payload
    },
    setListInspection: (state, action) => {
      state.listInspection = action.payload
    },
    setActivityDetail: (state, action) => {
      state.activityDetail = action.payload
    },
    setActivityDownload: (state, action) => {
      state.activityDownload = action.payload
    },
    setMainTabs: (state, action) => {
      state.mainTabs = action.payload
    },
    setSubFilters: (state, action) => {
      state.subFilters = action.payload
    },
    setDetailReport: (state, action) => {
      state.detailReport = action.payload
    },
    setStatusHistory: (state, action) => {
      state.statusHistory = action.payload
    }
  }
})
